module.exports = "<div class=\"filter-tag\" *ngFor=\"let rate of ratePlanCodes; index as i\">\n  <span class=\"filter-tag-text\" title={{getTitleFromRpc(rate)}}>{{rate.ratePlanCode}}</span>\n  <!-- This cannot be a button.  If this were a button, then clicking 'Enter' anywhere in the form will click it -->\n  <i *ngIf=\"showCloseIcon && rate.closeable\" class=\"far fa-times filter-tag-close\" (click)=\"removeRate(i)\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/rate-plan-code.component.html
// module id = S4zL
// module chunks = 0